<template>
  <div class="container" style="min-width: 900px">
    <p style="font-size:26px;display: inline-block;cursor:pointer">应用编辑</p>

    <div class="formStyle">
      <Form :model="formItem" :label-width="100" style="padding:20px">
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">上传应用</Col>
            <Col span="15">
              <Upload class="uploadAPK"
                      :show-upload-list="false"
                      action="/zm/cos/upload"
                      accept=".apk"
                      :format="['apk']"
                      :before-upload="checkApkUpload"
                      :on-success="apkUploadSuccess"
                      :on-error="apkUploadFail"
                      :on-remove="removeAPK"
                      :on-progress="handleApkUpload"
                      :on-format-error="handleFormatError"
                      :on-exceeded-size="handleMaxSize"
              ><div>
                <Spin v-if="apkProgress" fix>
                  <div>上传中</div>
                </Spin>
                <Input v-model="apkName" placeholder="点击上传APK"></Input>
              </div>
              </Upload>
            </Col>
          </Row>
        </formItem><!--apk上传-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">应用logo</Col>
            <Col span="15">
              <div class="logo-upload-list" v-for="item in logoUpload">
                <template>
                  <img :src="item">
                  <div class="logo-upload-list-cover">
                    <Icon type="ios-eye-outline" size="30" style="padding-right: 10px" @click.native="handleLogoView"></Icon>
                    <Icon type="ios-trash-outline" size="30" style="padding-right: 10px" @click.native="handleLogoRemove"></Icon>
                  </div>
                </template>
              </div>
              <Upload
                :show-upload-list="false"
                accept=".jpg,.jpeg,.png"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :on-progress="handleLogoUpload"
                :on-error="logoUploadFail"
                :on-success="logoUploadSuccess"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="checkLogoUpload"
                type="drag"
                action="/zm/cos/upload"
                style="display: inline-block;width:100px;">
                <div v-show="logoUpload.length < 1" style="width: 100px;height:100px;line-height: 100px;">
                  <Spin v-if="logoProgress" fix>
                    <div>上传中</div>
                  </Spin>
                  <Icon type="ios-camera" style="padding-top: 30px" size="40"></Icon>
                </div>
              </Upload>
              <Modal title="预览" v-model="logoVisible">
                <img :src="formItem.appLogo" v-if="logoVisible" style="width: 100%">
              </Modal>
              <br>
              <span>需上传完整正方形图标，尺寸：216*216px</span>
            </Col>
          </Row>
        </formItem><!--Logo上传-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">产品名称</Col>
            <Col span="15">
              <Input clearable
                     v-model="formItem.productTitle"
                     placeholder="请输入产品名称..."></Input>
            </Col>
          </Row>
        </formItem><!--产品名称-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">包名</Col>
            <Col span="15">
              <Input clearable
                     v-model="formItem.packageName"
                     placeholder="填写包名，如：mobi.accessible.qimingxing"
              ></Input>
            </Col>
          </Row>
        </formItem><!--包名-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">Appid</Col>
            <Col span="15">
              <Input clearable
                     v-model="formItem.appid"
                     placeholder="微信开发平台应用展示的AppID"
              ></Input>
            </Col>
          </Row>
        </formItem><!--产品appid-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">产品id</Col>
            <Col span="15">
              <Input clearable
                     v-model="formItem.productId"
                     placeholder="请输入产品id..."></Input>
            </Col>
          </Row>
        </formItem><!--产品id-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">应用版本</Col>
            <Col span="15">
              <Input clearable
                     v-model="formItem.appVersion"
                     placeholder="请输入版本号，如V1.0.1"></Input>
            </Col>
          </Row>
        </formItem><!--产品版本-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">上架时间</Col>
            <Col span="15">
              <DatePicker type="datetime"
                          clearable
                          placeholder="选择上架时间"
                          v-model="formItem.time"
                          style="width: 180px"></DatePicker>
            </Col>
          </Row>
        </formItem><!--上架时间-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">应用类别</Col>
            <Col span="15">
              <RadioGroup v-model="formItem.appCategory">
                <Radio label="1" >启明应用</Radio>
                <Radio label="2" >启明游戏</Radio>
                <Radio label="3" >其他应用</Radio>
                <Radio label="4" >其他游戏</Radio>
                <Radio label="5" >未分类</Radio>
              </RadioGroup>
            </Col>
          </Row>
        </formItem><!--应用类别-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">产品简介</Col>
            <Col span="15">
              <Input v-model="formItem.productShortDescribe"
                     type="textarea"
                     :maxlength="30"
                     placeholder="请输入一句话简介，限30字"></Input>
            </Col>
          </Row>
        </formItem><!--产品简介-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">产品详情</Col>
            <Col span="15">
              <Input v-model="formItem.productDescribe"
                     type="textarea"
                     :maxlength="2000"
                     :autosize="{minRows: 4,maxRows: 8}"
                     placeholder="应用介绍，20-2000字之间"></Input>
            </Col>
          </Row>
        </formItem><!--应用详情-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">展示视频</Col>
            <Col span="15">
              <div v-for="item in videoUpload">
                <template>
                  <video controls="controls" style="width:200px; height: 300px" :src="item"></video>
                  <Button style="margin-bottom: 30px" @click="removeVideo">删除视频</Button>
                </template>
              </div>
              <Upload
                :show-upload-list="false"
                accept=".mp4"
                :format="['mp4']"
                :on-error="videoUploadFail"
                :on-remove="removeVideo"
                :on-progress="handleVideoUpload"
                :on-success="videoUploadSuccess"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="checkVideoUpload"
                type="drag"
                action="/zm/cos/upload"
                style="display: inline-block;width:200px;">
                <div v-show="videoUpload.length < 1" style="width: 200px;height:300px;line-height: 300px;">
                  <Spin v-if="videoProgress" fix>
                    <div>上传中</div>
                  </Spin>
                  <Icon type="ios-camera" style="padding-top: 30px" size="40"></Icon>
                </div>
              </Upload>
            </Col>
          </Row>
        </formItem><!--视频上传-->
        <formItem>
          <Row>
            <Col span="4" class="formItemTitle">展示截图</Col>
            <Col span="15">
              <div class="img-upload-list" v-for="item in imgUpload">
                <template>
                  <img :src="item">
                  <div class="img-upload-list-cover">
                    <Icon type="ios-eye-outline" size="30" style="padding-right: 10px" @click.native="handleImgView(item)"></Icon>
                    <Icon type="ios-trash-outline" size="30" style="padding-right: 10px" @click.native="handleImgRemove(item)"></Icon>
                  </div>
                </template>
              </div>
              <Upload
                :show-upload-list="false"
                accept=".jpg,.jpeg,.png"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :on-progress="handleImgUpload"
                :on-success="imgUploadSuccess"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="checkImgUpload"
                type="drag"
                multiple
                action="/zm/cos/upload"
                style="display: inline-block;width:200px;">
                <div v-show="imgUpload.length < 5" style="width: 200px;height:300px;line-height: 300px;">
                  <Spin v-if="imgProgress" fix>
                    <div>上传中</div>
                  </Spin>
                    <Icon type="ios-camera" style="padding-top: 30px" size="40"></Icon>
                </div>
              </Upload>
              <Modal title="预览" v-model="imgVisible">
                <img :src="imgShow" v-if="imgVisible" style="width: 100%">
              </Modal>
              <br>
              <span>请上传最少3张截图，支持JPG\JPEG或PNG格式，建议分辨率：450*800（9：16）,单张图片最大为2M</span>
            </Col>
          </Row>
        </formItem><!--展示图上传-->
        <formItem style="text-align: center">
          <Button v-if="isNew" type="primary" @click="submitTotal">添加产品</Button>
          <Button v-else type="primary" @click="saveChange">提交修改</Button>
        </formItem>
      </Form>
    </div>

  </div>
</template>

<script>
    import {format2Sec} from "../../utils/format";
    import {adminRouter} from "../../router/admin";

    export default {
        name: "editWebAppDetail",
        data(){
            return{
                isNew: false,
                pageInfo: {},
                formItem:{},
                sortOrder: 0,
                productType: 5,
                apkName: '',
                logoVisible: false,
                logoUpload: [],
                videoUpload: [],
                imgUpload: [],
                imgVisible: false,
                imgShow: '',
                apkProgress: false,
                imgProgress: false,
                logoProgress: false,
                videoProgress: false
            };
        },
        methods:{
            /*通用上传控件*/
            handleFormatError () {
                this.$Message.error('文件格式错误');
            },
            handleMaxSize () {
                this.$Message.error('文件体积过大');
            },
            /*apk上传控件*/
            checkApkUpload(file){
                if (this.apkName !== ''){
                    this.$Message.error('只能上传一个apk文件');
                    return false;
                }
                this.apkName = file.name;
            },
            handleApkUpload(res, file, list){
                this.apkProgress = true;
            },
            apkUploadSuccess(res, file){
                this.formItem.downloadUrl = res.content;
                this.apkProgress = false;
                this.$Message.success('上传成功');
            },
            apkUploadFail(res, file){
                this.apkName = '';
                this.formItem.downloadUrl = '';
                this.apkProgress = false;
                this.$Message.error('上传失败，请重新上传');
            },
            removeAPK(){
                this.apkName = '';
                this.formItem.downloadUrl = '';
            },
            /*logo上传控件*/
            logoUploadSuccess(res, file){
                this.formItem.appLogo = res.content;
                this.logoUpload.push(res.content);
                this.logoProgress = false;
                this.$Message.success('上传成功');
            },
            logoUploadFail(){
                this.formItem.appLogo = '';
                this.logoUpload = [];
                this.logoProgress = false;
                this.$Message.error('上传失败，请重新上传');
            },
            checkLogoUpload(){
                if (this.logoUpload.length > 0){
                    this.$Message.error('只能上传一个Logo文件');
                    return false;
                }
            },
            handleLogoUpload(res, file, list){
                this.logoProgress = true;
            },
            handleLogoView () {
                this.logoVisible = true;
            },
            handleLogoRemove () {
                this.logoUpload = [];
                this.formItem.appLogo = '';
            },
            /*视频上传控件*/
            videoUploadSuccess(res, file){
                this.formItem.playerSrc = res.content;
                this.videoUpload.push(res.content);
                this.videoProgress = false;
                this.$Message.success('上传成功');
            },
            videoUploadFail(){
                this.formItem.playerSrc = '';
                this.videoUpload = [];
                this.videoProgress = false;
                this.$Message.error('上传失败，请重新上传');
            },
            handleVideoUpload(res, file, list){
                this.videoProgress = true;
            },
            checkVideoUpload(){
                if (this.videoUpload.length > 0){
                    this.$Message.error('只能上传一个视频文件');
                    return false;
                }
            },
            removeVideo(){
                this.formItem.playerSrc = '';
                this.videoUpload = [];
            },
            /*展示图上传控件*/
            imgUploadSuccess(res, file){
                this.imgUpload.push(res.content);
                this.imgProgress = false;
                this.$Message.success('上传成功');
            },
            handleImgUpload(res, file, list){
                this.imgProgress = true;
            },
            checkImgUpload(file){
                if (this.imgUpload.length > 4){
                    this.$Message.error('最多只能上传5张截图');
                    return false;
                }
            },
            handleImgView (url) {
                this.imgVisible = true;
                this.imgShow = url;
            },
            handleImgRemove (url) {
                this.imgUpload.splice(this.imgUpload.indexOf(url), 1);

            },

            showAppDetail(areaId, order){
                let active = 'webAppDetail';
                let currentTag = localStorage.getItem('currentTag');
                if (currentTag !== active){
                    let tags = null;
                    for (let ele of adminRouter){
                        if (ele.name === active){
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length){
                                for (let val of ele.children){
                                    if (val.name === active){
                                        tags = {
                                            title: val.title,
                                            name: val.name,
                                            path: val.path
                                        };
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    localStorage.setItem("currentTag", active);
                    localStorage.setItem("areaId", areaId);
                    localStorage.setItem("sortOrder", order);
                    this.$store.commit("updateCurrentTag", active);
                    this.$store.commit("updateOpenedTags", [tags]);
                    this.$store.commit("updateCurrentPath", active);
                    this.$router.push({
                        name: active
                    });
                }
            },
            saveChange(){
                this.formItem.posterSrc = this.imgUpload[0];
                for (let i=1; i < this.imgUpload.length; i++){
                    this.formItem.posterSrc = this.formItem.posterSrc + '分割' + this.imgUpload[i];
                }
                if (this.formItem.createDate){
                    this.formItem.createDate = this.formItem.time.getTime();
                }
                let areaId = this.formItem.areaId;
                delete this.formItem.time;
                this.$http.post('/zm/WMWebsite/updateProductInfo', this.formItem).then(
                    res => {
                        if (res.data.code === -1){
                            this.$Message.error(res.data.errorMsg);
                        }else {
                            this.$Message.success("上产成功！");
                            this.showAppDetail(areaId, this.sortOrder);
                        }
                        this.formItem={};
                        this.logoUpload=[];
                        this.videoUpload=[];
                        this.imgUpload = [];
                    },
                    err => {
                        this.$Message.error("提交失败！"+err.message);
                    }
                );
            },
            submitTotal(){
                this.formItem.posterSrc = this.imgUpload[0];
                for (let i=1; i < this.imgUpload.length; i++){
                    this.formItem.posterSrc = this.formItem.posterSrc + '分割' + this.imgUpload[i];
                }
                if (this.formItem.createDate){
                    this.formItem.createDate = this.formItem.time.getTime();
                }
                let areaId = this.formItem.areaId;
                delete this.formItem.time;
                this.$http.post('/zm/WMWebsite/addProductInfo', this.formItem).then(res => {
                    if (res.data.code === -1){
                        this.$Message.error(res.data.errorMsg);
                    }else {
                        this.$Message.success("上产成功！");
                        this.showAppDetail(areaId, this.sortOrder);
                    }
                    this.formItem={};
                    this.logoUpload=[];
                    this.videoUpload=[];
                    this.imgUpload = [];
                }, err => {
                    this.$Message.error("上传失败！"+err.message);
                });
            },
        },

        watch: {

        },
        created() {
        },
        activated() {
            this.apkName = '';
            this.formItem={};
            this.logoUpload=[];
            this.videoUpload=[];
            this.imgUpload = [];
            let areaId = Number(localStorage.getItem('areaId'));
            let area = 'productInfoArea' + areaId;
            let sortOrder = localStorage.getItem('sortOrder');
            if (sortOrder !== ''){
                this.isNew = false;
                let order = Number(sortOrder);
                this.sortOrder = order;
                this.$http.post('/zm/WMWebsite/queryProductInfos', {}).then(
                    res => {
                        let tempData = res.data.content;
                        this.formItem = tempData[area][order];
                        this.formItem.time = format2Sec(this.formItem.createDate);
                        if (this.formItem.posterSrc){
                            this.imgUpload = this.formItem.posterSrc.split('分割');
                        }
                        if (this.formItem.appLogo){
                            this.logoUpload.push(this.formItem.appLogo);
                        }
                        if (this.formItem.playerSrc){
                            this.videoUpload.push(this.formItem.playerSrc);
                        }
                        if (this.apkName){
                            this.apkName = this.formItem.downloadUrl;
                        }
                        this.formItem.appCategory = String(this.formItem.appCategory);
                    }
                );
            }else {
                this.isNew = true;
                let length = Number(localStorage.getItem('length'));
                this.formItem.areaId = areaId;
                this.formItem.sortId = length;
                this.sortOrder = length;
            }
        }
    };
</script>

<style>
  .container {
    padding: 0;
    margin: 20px 0 0 25px;
  }  /*全局配置*/
  .formStyle{
    background-color: #fff;
    margin:2% auto;
    width: 96%;
    border-radius: 5px;
  }  /*表单外观设置*/
  .formTitle{
    font-size: 20px;
    font-family: "黑体";
    padding:15px;
    text-align: center;
  }  /*表单标题*/
  .formItemTitle{
    font-size: 18px;
  }  /*表单项目标题*/
  .uploadAPK .ivu-upload-select{
    width: 100%;
  }
  .logo-upload-list{
    display: inline-block;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .logo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .logo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .logo-upload-list:hover .logo-upload-list-cover{
    display: block;
  }
  .logo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
  .img-upload-list{
    display: inline-block;
    width: 200px;
    height: 300px;
    text-align: center;
    line-height: 300px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .img-upload-list img{
    width: 100%;
    height: 100%;
  }
  .img-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .img-upload-list:hover .img-upload-list-cover{
    display: block;
  }
  .img-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>



// WEBPACK FOOTER //
// editWebAppDetail.vue?3c62cb14